import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { borderRadiusFromControlSize, colorToRgba, heightFromControlSize } from 'utils'
import MenuComponent from './menu'
import OptionsComponent from './options'

export const Container = styled.div<{ backgroundColor: string; controlSize: ControlSize; disabled: boolean }>`
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: ${({ controlSize }) => borderRadiusFromControlSize(controlSize, true)}px;
    position: relative;

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`

export const Dim = styled.div<{ backgroundColor: string; controlSize: ControlSize }>`
    border-bottom-right-radius: inherit;
    border-top-right-radius: inherit;
    height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;

    ${({ backgroundColor, controlSize }) => css`
        background: ${`linear-gradient(90deg, ${colorToRgba(backgroundColor, 0)}, ${colorToRgba(
            backgroundColor,
            1
        )}, ${colorToRgba(backgroundColor, 1)})`};
        width: ${heightFromControlSize(controlSize) * 2}px;
    `}
`

export const Menu = styled(MenuComponent)`
    position: absolute;
    right: 0;
    top: 0;
`

export const Options = styled(OptionsComponent)<{
    controlSize: ControlSize
    isTruncated: boolean
}>`
    border-radius: inherit;
    height: 100%;
    width: 100%;

    ${({ controlSize, isTruncated }) =>
        isTruncated &&
        css`
            overflow: hidden;
            position: relative;

            > button:last-child {
                margin-right: ${heightFromControlSize(controlSize)}px;
            }
        `}
`
